"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImageWrapper = exports.Image = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Container = _styledComponents.default.div`
  overflow: hidden;
`;
exports.Container = Container;
const ImageWrapper = _styledComponents.default.div`
  position: relative;
  padding: 0px 16px;
  width: 100%;

  @media (min-width: 768px) {
    padding: 0px;
    height: calc(100vh - 60px);
  }
`;
exports.ImageWrapper = ImageWrapper;
const Image = _styledComponents.default.img`
  margin-top: 8px;
  max-width: 100%;

  @media (min-width: 768px) {
    max-width: none;
    margin-top: 0px;
    min-height: 100%;
    min-width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
`;
exports.Image = Image;
//# sourceMappingURL=styles.js.map